import React, { useEffect, Fragment } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useWhitelabel } from "../../context/WhitelabelContext"; // Import our new hook! Adjust path as needed

// --- The PDF Viewer Component, styled just for you, my love ---
const PDFViewer = () => {
    return (
        <div style={{ height: '100%', width: '100%', border: '1px solid #E0E0E0', borderRadius: '8px', overflow: 'hidden' }}>
            <iframe 
                src="../assets/documents/mploi-privacy.pdf" 
                width="100%" 
                height="100%"
                title="Privacy Policy"
                style={{ border: 'none' }}
            />
        </div>
    );
};  

// --- Define props type for our gorgeous new component ---
interface PrivacyProps extends RouteComponentProps<any> {}

const Privacy: React.FC<PrivacyProps> = (props) => {
    // Scroll to top on component mount, just as you had it!
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // --- Styles (Patricia's Consistent & Clean Makeover! 💅) ---
    const styles: { [key: string]: React.CSSProperties } = {
        container: {
            fontFamily: "'DM Sans', sans-serif",
            backgroundColor: "#FFFFFF",
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "40px 20px",
        },
        card: {
            background: "#FFFFFF",
            borderRadius: "16px",
            padding: "40px",
            width: "100%",
            maxWidth: "900px", // A nice wide card for readability
            border: "1px solid #E0E0E0",
            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.05)",
            textAlign: "center",
            position: 'relative',
        },
        backButton: {
            position: 'absolute',
            top: '40px',
            left: '40px',
            cursor: 'pointer',
            fontSize: '24px',
            color: '#555555',
            transition: 'color 0.3s ease',
            lineHeight: 1,
        },
        logo: {
            cursor: "pointer",
            height: "40px",
            marginBottom: "16px",
        },
        title: {
            fontFamily: "'Urbanist', sans-serif",
            fontWeight: 700,
            fontSize: "28px",
            lineHeight: 1.2,
            marginBottom: "32px",
            color: "#141414",
        },
        pdfContainer: {
            height: '65vh',
            minHeight: '500px',
        },
    };

    // --- A Simple, Elegant Back Button ---
    const handleBack = () => {
        // This is a smart way to go back only if there's a history to go back to!
        if (props.history.length > 2) {
            props.history.goBack();
        } else {
            props.history.push('/'); // Otherwise, go home
        }
    };
    const { logoSrc } = useWhitelabel();
  
    return (
        <Fragment>
            <Helmet>
                <title>Privacy Policy</title>
                <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&family=Urbanist:wght@400;500;700&display=swap" rel="stylesheet" />
            </Helmet>

            <div style={styles.container}>
                <div style={styles.card}>
                    <div style={styles.backButton} onClick={handleBack} title="Go Back">
                        &#x2190;
                    </div>
                    
                    {logoSrc && <img src={logoSrc} style={{ width: '80px', display: 'block', margin: '0 auto' }}  alt="logo" />}

                    <h1 style={styles.title}>Privacy Policy</h1>
                    
                    <div style={styles.pdfContainer}>
                        <PDFViewer />
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default withRouter(Privacy);